export const tableColumn = [
    {
        title: "服务器名",
        slot: "game_name",
        align: "center",
        width: 116,
    },
    {
        title: "服务器IP",
        slot: "game_version_name",
        align: "center",
        width: 78,
    },
    {
        title: "开区时间 月/日/时",
        slot: "date",
        align: "center",
        width: 154,
    },
    {
        title: "线路类型",
        key: "game_tags",
        align: "center",
        width: 116,
    },
    {
        title: "版本介绍",
        slot: "game_desc",
        align: "center",
        width: 290,
    },
    {
        title: "客服QQ",
        slot: "labelList",
        align: "center",
        width: 154,
    },
    {
        title: "详细介绍",
        slot: "detail",
        align: "center",
        width: 116,
    },
];

// bdfb 路由表头
export const bdfbTableColumn = [
    { title: "智能推送", align: "center", width: 110 },
    { title: "游戏名称", align: "center", width: 160 },
    { title: "ip", align: "center", width: 140 },
    { title: "线路", align: "center", width: 140 },
    { title: "详细介绍", align: "center", width: 254 },
    { title: "客服QQ", align: "center", width: 116 },
    { title: "下载", align: "center", width: 104 },
];
